function normalize(value) {
  return String(value || '').trim().toUpperCase();
}

export function isManualNseStockStrategy(manualTrading) {
  return normalize(manualTrading?.exchange) === 'NSE'
    && normalize(manualTrading?.segment) === 'STOCK';
}

export function isManualPickerSymbolSelectable(manualTrading, row) {
  const symbol = normalize(row?.symbol);
  if (isManualNseStockStrategy(manualTrading)) {
    return symbol.startsWith('NSE:') && symbol.endsWith('-EQ');
  }

  if (normalize(manualTrading?.trade_in) !== 'OPTION') return true;
  const body = symbol.split(':').pop() || '';
  return !(/\d/.test(body) && (body.endsWith('CE') || body.endsWith('PE')));
}
